module.exports = __webpack_public_path__ + "img/icon-gasstation.3a29b7b4.svg";